module.exports = __webpack_public_path__ + "img/chinesecompany77.36318c9e.png";